import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AddEmployee from "./AddEmployee";
import AllEmployee from "./AllEmployee";
import Dashboard from "./Dashboard";
import DepartmentManagement from "./DepartmentManagement";
import DesignationManagement from "./DesignationManagement";
import Profile from "./Profile";
import RoleManagement from "./RoleManagement";
import Layout from "./Layout";
import GradeManagement from "./GradeManagement";
import HolidayManagement from "./HolidayManagement";
import EmployeeDetails from "./EmployeeDetails";
import AttendanceLog from "./AttendanceLog";
import AddRole from "./AddRole";
import EditRole from "./EditRole";
import ViewEmployee from "./ViewEmployee";
import LeaveRequests from "./LeaveRequests";
import Notifications from "./Notifications";
import Payroll from "./Payroll";
import AddCandidate from "./AddCandidate";
import Onboarding from "./Onboarding";
import UpdateCandidate from "./UpdateCandidate";
import GenerateDocument from "./GenerateDocument";
import EditSalary from "./EditSalary";

const AdminRoute = () => {
  return (
    <Routes>
      <Route
        exact
        path="/"
        element={
          <Layout>
            <Dashboard />
          </Layout>
        }
      />
      <Route
        exact
        path="/employees"
        element={
          <Layout>
            <AllEmployee />
          </Layout>
        }
      />
      <Route
        exact
        path="/add-employee"
        element={
          <Layout>
            <AddEmployee />
          </Layout>
        }
      />
      <Route
        exact
        path="/employee/:id"
        element={
          <Layout>
            <EmployeeDetails />
          </Layout>
        }
      />
      <Route
        exact
        path="/view-employee/:id"
        element={
          <Layout>
            <ViewEmployee />
          </Layout>
        }
      />
      <Route
        exact
        path="/attendance-log"
        element={
          <Layout>
            <AttendanceLog />
          </Layout>
        }
      />
      <Route
        exact
        path="/role-management"
        element={
          <Layout>
            <RoleManagement />
          </Layout>
        }
      />
      <Route
        exact
        path="/add-role"
        element={
          <Layout>
            <AddRole />
          </Layout>
        }
      />
      <Route
        exact
        path="/edit-role/:id"
        element={
          <Layout>
            <EditRole />
          </Layout>
        }
      />
      <Route
        exact
        path="/designation-management"
        element={
          <Layout>
            <DesignationManagement />
          </Layout>
        }
      />
      <Route
        exact
        path="/department-management"
        element={
          <Layout>
            <DepartmentManagement />
          </Layout>
        }
      />
      <Route
        exact
        path="/grade-management"
        element={
          <Layout>
            <GradeManagement />
          </Layout>
        }
      />
      <Route
        exact
        path="/holiday-management"
        element={
          <Layout>
            <HolidayManagement />
          </Layout>
        }
      />
      <Route
        exact
        path="/profile"
        element={
          <Layout>
            <Profile />
          </Layout>
        }
      />
      <Route
        exact
        path="/notifications"
        element={
          <Layout>
            <Notifications />
          </Layout>
        }
      />
      <Route
        exact
        path="/leave-requests"
        element={
          <Layout>
            <LeaveRequests />
          </Layout>
        }
      />
      <Route
        exact
        path="/add-candidate"
        element={
          <Layout>
            <AddCandidate />
          </Layout>
        }
      />
      <Route
        exact
        path="/payroll"
        element={
          <Layout>
            <Payroll />
          </Layout>
        }
      />
      <Route
        path="/edit-salary/:id"
        element={
          <Layout>
            <EditSalary />
          </Layout>
        }
      />
      <Route
        exact
        path="/onboarding"
        element={
          <Layout>
            <Onboarding />
          </Layout>
        }
      />
      <Route
        exact
        path="/add-candidate"
        element={
          <Layout>
            <AddCandidate />
          </Layout>
        }
      />
      <Route
        exact
        path="/edit-candidate/:id"
        element={
          <Layout>
            <UpdateCandidate />
          </Layout>
        }
      />
      <Route
        exact
        path="/requested-documents"
        element={
          <Layout>
            <GenerateDocument />
          </Layout>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AdminRoute;
